"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cn = require("classnames");
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
const Icon_1 = require("../Icon");
const DumpIconItem = ({ className, data: { icon, title, subtitle, description, rootTag: RootTag = 'div', titleTag: TitleTag = 'div', subtitleTag: SubtitleTag = 'div', descriptionTag: DescriptionTag = 'div', theme: overrideTheme, }, theme: defaultTheme, ...rest }) => {
    const theme = { ...(defaultTheme || {}), ...(overrideTheme || {}) };
    return (React.createElement(RootTag, Object.assign({ className: cn(theme.root, className) }, rest),
        React.createElement("div", { className: theme.iconWrapper },
            React.createElement(Icon_1.default, { className: theme.icon, icon: icon })),
        React.createElement("div", { className: theme.content },
            title && React.createElement(TitleTag, { className: theme.title }, title),
            subtitle && (React.createElement(SubtitleTag, { className: theme.subtitle }, subtitle)),
            description && (React.createElement(DescriptionTag, { className: theme.description }, description)))));
};
exports.defaultIconItemTheme = {};
const IconItem = react_css_themr_1.themr('IconItem', {}, { composeTheme: 'softly' })(DumpIconItem);
exports.default = IconItem;
//# sourceMappingURL=index.js.map